function ClearIcon({ width = '7', height = '7' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 7 7"
    >
      <g
        id="Group_43323"
        data-name="Group 43323"
        transform="translate(-1 -0.605)"
      >
        <path
          id="Path_29648"
          data-name="Path 29648"
          d="M9.136,8.358l2.722-2.722.778.778L9.914,9.136l2.722,2.722-.778.778L9.136,9.914,6.414,12.636l-.778-.778L8.358,9.136,5.636,6.414l.778-.778Z"
          transform="translate(-4.636 -5.031)"
          fill="#333"
        />
      </g>
    </svg>
  );
}

export default ClearIcon;
